/**
 * Mobile profile sticky footer behaviour:
 *  - guest "add to favorites" gate (login / visitor sign-up bottom-sheet);
 *  - "more contacts" scrolls to the Contacts section;
 *  - hidden-number reveal for the primary call button (is_phone_visible = false).
 *
 * Phone reveal for the visible/screening branches, analytics clicks and the policy
 * modal are already handled by the shared hooks (js-analytics-click / js-policy-button).
 */

// --- Guest favorite gate ---
const gate = document.getElementById('favoriteGateModal');

if (gate) {
	const openGate = () => {
		gate.classList.remove('hidden');
		gate.setAttribute('aria-hidden', 'false');
		document.body.style.overflow = 'hidden';
	};

	const closeGate = () => {
		gate.classList.add('hidden');
		gate.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
	};

	document.querySelectorAll('.js-favorite-gate')
			.forEach((btn) => btn.addEventListener('click', openGate));

	gate.querySelectorAll('.js-favorite-gate-close')
		.forEach((el) => el.addEventListener('click', closeGate));

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && !gate.classList.contains('hidden')) {
			closeGate();
		}
	});
}

// --- Tuck the bar away once the real page footer is reached, so it stays readable ---
const bar        = document.querySelector('.js-profile-sticky-footer');
const pageFooter = document.querySelector('footer');

if (bar && pageFooter && 'IntersectionObserver' in window) {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			bar.classList.toggle('is-tucked', entry.isIntersecting);
		});
	}, {rootMargin: '0px 0px 24px 0px'});

	observer.observe(pageFooter);
}

// --- Hidden-number reveal: first tap reveals the number and turns the button into a tel: link ---
document.querySelectorAll('.js-footer-reveal-phone').forEach((btn) => {
	btn.addEventListener('click', function () {
		const encoded = this.dataset.phone;

		if (!encoded) {
			return;
		}

		const phone   = atob(encoded);
		const textEl  = this.querySelector('.js-footer-phone-text');

		if (textEl) {
			textEl.textContent = phone;
		}

		const link = document.createElement('a');

		link.className = this.className
						 .replace('js-analytics-click', '')
						 .replace('js-footer-reveal-phone', '')
						 .trim();
		link.href      = 'tel:' + phone.replace(/[^\d+]/g, '');
		link.innerHTML = this.innerHTML;

		this.replaceWith(link);
	});
});
